import { type Jast, walkAST, print } from '@atlaskit/jql-ast';
import type { TextSearchInputClauseType } from '../../common/types.tsx';
import { IsInCompoundClauseVisitor } from '../is-in-compound-clause-visitor.tsx';

/**
 * Removes fields from the JQL AST that are not in the requiredFields set.
 * Eg. used by jql builder basic to remove only optional fields from the ast and don't touch irremovable fields or text search input
 */
export const removeOptionalFieldsFromJql = (
	ast: Jast,
	requiredFields: Set<string>,
	textSearchInputClause?: TextSearchInputClauseType,
): string => {
	walkAST(
		{
			enterTerminalClause(terminalClause) {
				const isTextSearchInput =
					textSearchInputClause &&
					new IsInCompoundClauseVisitor(terminalClause).visit(textSearchInputClause);

				if (!requiredFields.has(terminalClause.field.value.toLowerCase()) && !isTextSearchInput) {
					terminalClause.remove();
				}
			},
		},
		ast,
	);
	return print(ast, {
		operatorCase: 'upper',
	});
};
